import { Overview } from "./components/Overview/Overview";
import { Referrals } from "./components/Referrals/Referrals";
import { Summary } from "./components/Summary/Summary";

export const ReferralStats = () => {
  return (
    <div>
      <Overview />
      <Referrals />
      <Summary />
    </div>
  );
};
